<template>
  <div class="inline">
    <div v-if="isAddressable" class="tooltip-container" :style="cssProps">
      <div class="tooltip-title">{{ title }}</div>
      <div class="status-bar">
        <ul>
          <li :class="{complete: isPlanned, planning: isPlanning}">{{ planningText }}
            <div :class="{'progress-line':true, complete: isPlanned}"></div>
          </li>
          <li :class="{complete: isOrdered}">{{ orderingText }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { DESTINATIONS, ACTIVATION_STATUS } from '@/appLogic/targets/Constants'

export default {
  data () {
    return {
      topPosition: 0,
      showStatusWidget: false,
      targetData: {}
    }
  },
  beforeMount () {
    this.targetData = this.params.api.getDisplayedRowAtIndex(this.params.rowIndex).data

    let row = document.querySelector('div[col-id="activation_status"]')
    if (row) {
      this.getTopPosition(row)
    }
  },
  computed: {
    cssProps () {
      return {
        'bottom': this.topPosition - 35 + 'px'
      }
    },
    title () {
      if (!this.targetData) return

      return this.targetData.activation_status
    },
    isAddressable () {
      if (!this.targetData) return

      return this.targetData.destinations && this.targetData.destinations.some((destination) => [DESTINATIONS.DIRECTV, DESTINATIONS.VIZIO, DESTINATIONS.CANOE_LINEAR, DESTINATIONS.CANOE_VOD].includes(destination))
    },
    isPlanning () {
      if (!this.targetData) return

      const planning_statuses = [ACTIVATION_STATUS.WORKING, ACTIVATION_STATUS.DRAFT, ACTIVATION_STATUS.MODELING]

      return planning_statuses.includes(this.targetData.activation_status)
    },
    isPlanned () {
      if (!this.targetData) return

      const planned_statuses = [ACTIVATION_STATUS.LIVE, ACTIVATION_STATUS.SUBMITTED]

      return planned_statuses.includes(this.targetData.activation_status) && this.targetData.activation_date !== null
    },
    planningText () {
      return this.isPlanned ? 'Planned' : 'Planning'
    },
    isOrdered () {
      if (!this.targetData || !this.isPlanned || !this.targetData.am_data || !this.targetData.am_data.order) return

      return this.targetData.am_data.order.orderId !== null
    },
    orderingText () {
      return this.isOrdered ? 'Ordered' : 'Ordering'
    },
    currentTarget () {
      return this.$store.getters.currentTarget
    }
  },
  methods: {
    getTopPosition (element) {
      let y = 0
      while (true) {
        y += element.offsetTop
        if (element.offsetParent === null) {
          break
        }
        element = element.offsetParent
      }
      this.topPosition = y
    }
  }
}
</script>

<style lang='scss' scoped>
  // Parent
  .inline {
    position:absolute;
    transition: opacity .5s;
  }
  .inline.ag-tooltip-hiding {
    opacity: 0;
  }

  // Container (black rectangle)
  .tooltip-container {
    background: black;
    box-shadow: 0 6px 6px rgba(16, 16, 16, 0.04), 0 6px 6px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    height: 90px;
    width: 250px;
    margin: 0;
    padding: 2px;
    pointer-events: none;
    position:relative;
    bottom: var('bottom');
    right: 150px;
    z-index: 2;
  }

  // Triangle/arrow on the right
  .tooltip-container:after, .tooltip-container:before {
    bottom: 35%;
    left: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    transform: rotate(90deg);
  }
  .tooltip-container:after {
    border-color: rgba(238, 238, 238, 0);
    border-bottom-color: black;
    border-width: 15px;
  }
  .tooltip-container:before {
    border-color: rgba(204, 204, 204, 0);
    border-bottom-color: black;
    border-width: 16px;
  }

  // Title
  .tooltip-title {
    color: white;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    margin: 5px 0px;
    align-self: auto;
  }

  // Base progress icon
  .status-bar li {
    width: 105px;
    list-style-type: none;
    float: left;
    font-size: 11px;
    font-weight: bold;
    position: relative;
    text-transform: uppercase;
    text-align: left;
    color: #797979;
  }
  .status-bar li:before {
    width: 15px;
    height: 15px;
    content:'';
    border: 6px solid #797979;
    display: block;
    text-align: center;
    margin: 0px 17px 6px 17px;
    border-radius: 50%;
    background-color: #797979;
  }
  .status-bar li:after {
    width: 105px;
    height: 9px;
    position: absolute;
    content: '';
    background-color: #797979;
    top: 10px;
    left: -70%;
    z-index: -2;
  }
  .status-bar li:first-child:after {
    content: none;
  }

  // Planning coloring and animation
  .status-bar li.planning {
    color: white
  }
  .status-bar li.planning::before {
    color: black;
    font-size: 13px;
    font-weight: 900;
    animation: col 600ms linear forwards;
  }

  @keyframes col {
    0% {
      background-color: #797979;
      border-color: #797979;
      content:'';
    }
    33% {
      content:'.';
    }
    66% {
      content:'..';
    }
    100% {
      background-color: white;
      border-color: white;
      content:'...';
    }
  }

  // Completed step color and animation
  .status-bar li.complete {
    color: #ffcc00;
  }

  .status-bar li.complete:first-of-type + li {
    color: white;
  }

  .status-bar li.complete:first-of-type + li::before {
    background-color: white;
    border-color: white;
    color: black;
    font-size: 13px;
    font-weight: 900;
    animation: col2 750ms linear forwards;
  }

  @keyframes col2 {
    0% {
      content:'';
    }

    33% {
      content:'.';
    }

    66% {
      content:'..';
    }

    100% {
      content:'...';
    }
  }

  .status-bar li.complete:first-of-type + li.complete {
    color: #ffcc00;
  }

  .status-bar li.complete:first-of-type + li.complete::before {
    border-color: #ffcc00;
    background-color: #ffcc00;
    content:url('../../assets/check.png');
    animation: none;
  }

  .status-bar li.complete + li.complete:after {
    background: #ffcc00;
    width: 105px;
    z-index: -1;
    animation: none;
  }

  .status-bar li.complete:first-child:after {
    background-color: #ffcc00;
  }

  .status-bar li.complete:before {
    border-color: #ffcc00;
    background-color: #ffcc00;
    content:url('../../assets/check.png');
  }
  .status-bar li.complete + li:after {
    background: #ffcc00;
    width: 65px;
    z-index: -1;
    animation: line 700ms linear forwards;
  }
  @keyframes line {
    from {
      width:0%;
    }
    to {
      width:65%;
    }
  }
  .status-bar li.complete:first-child:after {
    background-color: #ffcc00;
  }

  // Background of the progress bar between nodes
  .progress-line{
    position: absolute;
    width: 105px;
    height: 9px;
    background-color: #797979;
    top: 10px;
    left: 35px;
    z-index: -3;
  }
  .progress-line.complete{
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// AddressableStatusIndicator.vue?4436bf39